<div id="layout" class="theme-cyan">

  <div class="authentication">

    <div class="container d-flex flex-column">

      <div class="row align-items-center justify-content-center no-gutters min-vh-100">

        <div class="col-12 col-md-7 col-lg-5 col-xl-4 py-md-11">

          <div class="card border-0 shadow-sm">
            <div class="card-body">
              <!-- Heading -->
              <h3 class="text-center display-2">404</h3>

              <!-- Text -->
              <p class="text-center mb-6">Sorry, the page you're looking for cannot be found.</p>

              <!-- Form -->
              <form class="mb-4 mt-5">
                <!-- Submit -->
                <div class="text-center mt-5">
                  <a [routerLink]="['/dashboard']" href="javascript:void(0)" class="btn btn-lg btn-primary" title="">Go
                    back to the App</a>
                </div>
              </form>

              <!-- Text -->
              <p class="text-center mb-0">if you think this might be an error.<br> <a class="link"
                  href="javascript:void(0);">Contact
                  Us</a>.</p>
            </div>
          </div>

        </div>

        <div class="signin-img d-none d-lg-block text-center">
          <img src="assets/images/signin-img-cyan.svg" alt="Sign In Image" />
        </div>

      </div> <!-- / .row -->

    </div>

  </div>

</div>
